
//测试环境
window.REPORT_DOMAIN = "https://dev-mqce.gkgzj.com/";

